import React from 'react';
import { Badge } from '@/components/ui/badge';

/**
 * Shared communication-policy badge used by any awareness surface
 * (Agents list, Agency Profile, Agent Profile). Purely presentational —
 * callers pass `value` (one of the three canonical enum strings) and,
 * optionally, `size` for compact table cells.
 *
 * Do NOT show governance reasons/dates here — this is the operational
 * awareness badge; details live in the AgentCommunicationException block
 * on the Agent Profile.
 */
export const COMMUNICATION_POLICY_LABELS = {
  direct_contact_allowed: 'Direct Contact Allowed',
  agency_coordination_required: 'Agency Coordination Required',
  restricted_direct_contact: 'Restricted Direct Contact',
};

export const COMMUNICATION_POLICY_SHORT_LABELS = {
  direct_contact_allowed: 'Direct Contact',
  agency_coordination_required: 'Agency Coordination',
  restricted_direct_contact: 'Restricted',
};

const TONE = {
  direct_contact_allowed: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  agency_coordination_required: 'bg-amber-100 text-amber-700 border-amber-200',
  restricted_direct_contact: 'bg-rose-100 text-rose-700 border-rose-200',
};

export const COMMUNICATION_SOURCE_LABELS = {
  agent_override: 'Agent Exception',
  agent_exception: 'Agent Exception',
  agency_default: 'Agency Policy',
  platform_default: 'Platform Default',
  agency: 'Agency Policy',
  platform: 'Platform Default',
};

export const CommunicationPolicyBadge = ({ value, short = false, className = '' }) => {
  if (!value) return null;
  const label = short
    ? (COMMUNICATION_POLICY_SHORT_LABELS[value] || value)
    : (COMMUNICATION_POLICY_LABELS[value] || value);
  return (
    <Badge
      className={`text-xs border ${TONE[value] || 'bg-slate-100 text-slate-700 border-slate-200'} ${className}`}
      data-testid={`communication-policy-badge-${value}`}
    >
      {label}
    </Badge>
  );
};

export default CommunicationPolicyBadge;
